import { string, object, func, bool, node } from 'prop-types'
import { Fragment } from 'react'
import { Asset, renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { ContentTextInput } from '../../../../../ContentTextInput'
import { sharedColors } from '../sharedStyles'
import { styles } from './styles.js'

const EMPTY_COLLAB_LABEL = 'No collab account'

export const MobileSingle = ({
  accountImage,
  assetSlot,
  collabEnabled,
  collabAccount,
  content,
  isHovered,
  isPresenting,
  isSnapshot = false,
  onContentChange,
  onSoundChange,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
  sound,
  truncate,
  username,
  video,
}) => (
  <Fragment>
    <div
      css={styles.gradientLayer.top}
      className={kuiperClassNames('tiktok-gradient-layer')}
    />

    {renderIcon('tiktok-mobile-chevron-west', {
      ...styles.chevronIcon,
      ariaMode: 'hidden',
    })}

    {assetSlot && !video ? (
      assetSlot
    ) : (
      <Asset
        hasAssetOverlay={!isSnapshot && (Boolean(video) || isPresenting)}
        disableCoverAsset={false}
        assetReference={video}
        imageFit="contain"
        readOnly={readOnly}
        isHovered={isHovered}
        placeholder={true}
        preview={isSnapshot}
        removeable={!isPresenting}
        onEmbiggen={() => onExpandAsset(video.id)}
        onRemove={() => onRemoveAsset(video.id)}
      />
    )}

    <div
      css={styles.postContent}
      className={kuiperClassNames('tiktok-post-content')}
    >
      <div
        css={styles.postContent.avatarUsername}
        className={kuiperClassNames('tiktok-username')}
      >
        <div
          css={styles.nameRow}
          className={kuiperClassNames({ [styles.withCollab]: collabEnabled })}
        >
          <AccountName
            color={sharedColors.white()}
            noAccountColor={sharedColors.orange}
            name={username}
            size={15}
          />
          {collabEnabled && (
            <Fragment>
              <span css={styles.collabSeparator}> and </span>
              <AccountName
                color={
                  collabAccount ? sharedColors.white() : sharedColors.orange
                }
                name={collabAccount || EMPTY_COLLAB_LABEL}
                size={15}
              />
            </Fragment>
          )}
        </div>
        <p>
          <span>&#x25CF;</span> 1m ago
        </p>
      </div>
      <div>
        <ContentTextInput
          characterLimit={2200}
          characterCounterOptions={{ position: 'right', offset: 42 }}
          minRows={1}
          maxRows={4}
          maxLength={2200}
          truncate={truncate}
          truncationLimit={140}
          onChange={onContentChange}
          placeholder="Add caption..."
          placeholderStyle={styles.inputPlaceholder}
          style={styles.captionInput}
          readOnly={readOnly}
          value={content || ''}
        />
      </div>
      <div>
        {renderIcon('tiktok-mobile-sound', {
          ...styles.postContent.soundIcon,
          ariaMode: 'hidden',
        })}
        <ContentTextInput
          minRows={1}
          maxRows={4}
          truncate={truncate}
          truncationLimit={25}
          onChange={onSoundChange}
          placeholder="Add sound..."
          placeholderStyle={styles.inputPlaceholder}
          readOnly={readOnly}
          style={styles.soundInput}
          value={sound || ''}
        />
      </div>
    </div>

    <div
      css={styles.iconsBar}
      className={kuiperClassNames('tiktok-post-icons-bar')}
    >
      <ul>
        <li>
          <ContentAvatar
            assetReference={accountImage}
            size={40}
            style={styles.avatar}
          />
        </li>
        <li>
          {renderIcon('tiktok-mobile-heart', {
            ...styles.iconsBar.heartIcon,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon('tiktok-mobile-comment', {
            ...styles.iconsBar.commentIcon,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon('tiktok-mobile-favorite', {
            ...styles.iconsBar.favoriteIcon,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon('tiktok-mobile-share', {
            ...styles.iconsBar.shareIcon,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon('tiktok-mobile-record', {
            ...styles.iconsBar.recordIcon,
            ariaMode: 'hidden',
          })}
        </li>
      </ul>
    </div>

    <div
      css={styles.commentBar}
      className={kuiperClassNames('tiktok-post-comment-bar')}
    >
      <p>Add comment...</p>
      <ul>
        <li>
          {renderIcon('tiktok-mobile-mention', {
            ...styles.commentBar.icon,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon('tiktok-mobile-emoji', {
            ...styles.commentBar.icon,
            ariaMode: 'hidden',
          })}
        </li>
      </ul>
    </div>

    <div
      css={styles.gradientLayer.bottom}
      className={kuiperClassNames('tiktok-gradient-layer')}
    />
  </Fragment>
)

MobileSingle.propTypes = {
  accountImage: object,
  assetSlot: node,
  collabEnabled: bool,
  collabAccount: string,
  content: string,
  isHovered: bool,
  isPresenting: bool,
  isSnapshot: bool,
  onContentChange: func,
  onExpandAsset: func,
  onRemoveAsset: func,
  onSoundChange: func,
  readOnly: bool,
  sound: string,
  truncate: bool,
  username: string,
  video: object,
}
